import * as React from 'react';
import debounce from 'lodash/debounce';
import { Input } from 'antd';

export interface SearchBoxProps {
  defaultValue?: string;
  hiddenEnabled?: boolean;
  onSearch?: (value: string) => void;
}

const SearchBox = (props: SearchBoxProps) => {
  const { defaultValue, onSearch } = props;
  const handleSearch = React.useMemo(
    () =>
      debounce((e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        onSearch?.(value);
      }, 300),
    [onSearch],
  );

  return (
    <Input.Search
      autoFocus
      defaultValue={defaultValue}
      placeholder="Search"
      allowClear
      style={{ maxWidth: 445 }}
      onChange={handleSearch}
      onSearch={onSearch}
    />
  );
};

export default SearchBox;
